import React from 'react';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen pt-20">
      <section className="relative h-80 flex items-center justify-center overflow-hidden bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900">
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Privacy Policy</h1>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            TOTAL VISION Oil and Gas Fields Services and Consultancy LLC SPC
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-slate max-w-none">
            <p className="text-lg text-slate-700 leading-relaxed mb-8">
              At TOTAL VISION Oil and Gas Fields Services and Consultancy LLC SPC, we are committed to protecting the privacy, confidentiality, and security of all personal, technical, and business information entrusted to us. This Privacy Policy outlines how we collect, use, store, and safeguard information across our engineering, consultancy, construction, and oil & gas field services.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">1. Introduction</h2>
            <p className="text-slate-700 leading-relaxed mb-6">
              TOTAL VISION respects the privacy of its clients, employees, partners, and stakeholders. We handle all information responsibly and in accordance with applicable data protection laws, industry standards, and internal governance procedures. This policy applies to all services, digital platforms, communications, and interactions with TOTAL VISION.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">2. Information We Collect</h2>
            
            <h3 className="text-xl font-semibold text-slate-900 mt-6 mb-3">A. Personal Information</h3>
            <p className="text-slate-700 leading-relaxed mb-3">
              We may collect personal data necessary for business operations, including:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-6">
              <li>Name, job title, and contact details</li>
              <li>Identification documents for site access or regulatory compliance</li>
              <li>Employment history, qualifications, and certifications</li>
              <li>Emergency contact information for employees and contractors</li>
            </ul>

            <h3 className="text-xl font-semibold text-slate-900 mt-6 mb-3">B. Business & Technical Information</h3>
            <p className="text-slate-700 leading-relaxed mb-3">
              As part of our oil & gas services, we may collect:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-6">
              <li>Engineering documents, project specifications, and technical data</li>
              <li>Vendor and subcontractor information</li>
              <li>Commercial proposals, contracts, and procurement records</li>
              <li>Operational, site related, and HSE documentation</li>
            </ul>

            <h3 className="text-xl font-semibold text-slate-900 mt-6 mb-3">C. Digital Information</h3>
            <p className="text-slate-700 leading-relaxed mb-3">
              We may collect digital data such as:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-6">
              <li>Website usage analytics (cookies, IP address, browser type)</li>
              <li>Emails, online forms, and communication logs</li>
              <li>Access logs for project collaboration platforms (e.g., EDMS/PMIS systems)</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">3. How We Use Your Information</h2>
            <p className="text-slate-700 leading-relaxed mb-3">
              Information is used strictly for legitimate business purposes, including:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-6">
              <li>Delivering engineering, consultancy, and field services</li>
              <li>Managing contracts, procurement, and supply chain activities</li>
              <li>Ensuring safety, security, and regulatory compliance</li>
              <li>Facilitating communication with clients, vendors, and partners</li>
              <li>Improving service quality, operational efficiency, and project performance</li>
              <li>Managing HR, recruitment, and employee development programs</li>
            </ul>
            <p className="text-slate-700 leading-relaxed font-semibold mb-6">
              TOTAL VISION does not sell, rent, or trade personal information under any circumstances.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">4. Information Sharing</h2>
            <p className="text-slate-700 leading-relaxed mb-3">
              We may share information only when necessary and only with:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-6">
              <li>Project partners, subcontractors, and vendors involved in service delivery</li>
              <li>Regulatory authorities and government bodies when required by law</li>
              <li>Third party service providers (IT, logistics, auditing, training) under confidentiality agreements</li>
              <li>HSE and security authorities for site access and compliance</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-6">
              All third parties are required to maintain strict confidentiality and data protection standards.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">5. Data Security</h2>
            <p className="text-slate-700 leading-relaxed mb-3">
              TOTAL VISION implements robust technical and organizational measures to protect information, including:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-6">
              <li>Secure servers, encrypted communication, and controlled access</li>
              <li>Cybersecurity protocols and regular system monitoring</li>
              <li>Confidentiality agreements and employee training</li>
              <li>Strict handling of sensitive engineering and operational data</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-6">
              We continuously enhance our systems to protect against unauthorized access, loss, or misuse.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">6. Data Retention</h2>
            <p className="text-slate-700 leading-relaxed mb-6">
              Information is retained only for as long as necessary to meet business, legal, or regulatory requirements. After retention periods expire, data is securely deleted or anonymized.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">7. Your Rights</h2>
            <p className="text-slate-700 leading-relaxed mb-3">
              Depending on applicable laws, individuals may have the right to:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-6">
              <li>Access their personal information</li>
              <li>Request corrections or updates</li>
              <li>Request deletion where legally permissible</li>
              <li>Withdraw consent for specific uses</li>
              <li>Raise concerns regarding data handling</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-6">
              Requests can be submitted through TOTAL VISION's official communication channels.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">8. Cookies and Digital Tracking</h2>
            <p className="text-slate-700 leading-relaxed mb-6">
              Our website may use cookies to enhance user experience and analyze performance. Users may adjust browser settings to manage or disable cookies.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">9. Policy Updates</h2>
            <p className="text-slate-700 leading-relaxed mb-6">
              TOTAL VISION may update this Privacy Policy periodically to reflect changes in regulations, technology, or business practices. Updated versions will be published on our official platforms.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mt-12 mb-4">10. Contact Information</h2>
            <p className="text-slate-700 leading-relaxed mb-3">
              For questions, concerns, or requests related to this Privacy Policy, please contact:
            </p>
            <p className="text-slate-900 font-semibold mb-2">
              TOTAL VISION Oil and Gas Fields Services and Consultancy LLC SPC
            </p>
            <p className="text-slate-700 leading-relaxed">
              Official communication channels will be provided upon request.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;